import { useContext, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createAppState } from "./AppState";
import { signal } from "@preact/signals-react";

export const drawMenuItems = signal([]); // expected: array of <MenuItem ... />

export default function SelectDraw() {
    const { draws, selectedDraw } = useContext(createAppState);

    useEffect(() => {
        const items = drawMenuItems.value;
        if (!items || items.length === 0) return;

        // Highest index = last MenuItem in drawMenuItems
        const latestDraw = items[0];
        const lastValue = latestDraw?.props?.value;

        if (lastValue === undefined) return;

        // Only set a default if:
        // - nothing is selected yet, OR
        // - current selection no longer exists in the menu
        const current = selectedDraw.value;
        const values = new Set(items.map((it) => it?.props?.value));

        const hasSelection = current !== undefined && current !== null && current !== "";
        const selectionStillValid = values.has(current);

        if (!hasSelection || !selectionStillValid) {
            selectedDraw.value = lastValue;
        }
    }, [drawMenuItems.value, draws.value, selectedDraw]);

    return (
        <FormControl fullWidth>
            <InputLabel id="draws-menu" required>
                Draw
            </InputLabel>
            <Select
                id="select-draws"
                value={selectedDraw.value}
                label="draw *"
                onChange={(event) => {
                    selectedDraw.value = event.target.value;
                }}
                disabled={draws.value.length <= 0}
                variant="filled"
            >
                {drawMenuItems.value}
            </Select>
        </FormControl>
    );
}
